import { useState } from 'react';

export default function FinalCTA() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneZaloWhatsapp: '',
    numberOfGuests: '2',
    tourType: '3-island',
    expectedDate: '',
    notes: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4hb9u3amli27834gg70', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          fullName: '',
          email: '',
          phoneZaloWhatsapp: '',
          numberOfGuests: '2',
          tourType: '3-island',
          expectedDate: '',
          notes: ''
        });
        
        // Redirect to thank you page after 1 second
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 1000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="final-cta" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
            Sẵn sàng khám phá <span className="text-[#2563eb]">Hawaii 2026</span> chưa?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-4">
            Tour giới hạn - Ưu đãi đặc biệt cho nhóm đăng ký sớm
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-lg">
            <div className="flex items-center text-[#2563eb] font-semibold">
              <i className="ri-checkbox-circle-fill mr-2"></i>
              Giảm 5% cho nhóm 8+ người
            </div>
            <div className="flex items-center text-[#2563eb] font-semibold">
              <i className="ri-checkbox-circle-fill mr-2"></i>
              Giảm 3% đăng ký trước 3 tháng
            </div>
            <div className="flex items-center text-[#2563eb] font-semibold">
              <i className="ri-checkbox-circle-fill mr-2"></i>
              Tặng bảo hiểm $50
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left: Benefits */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Đăng ký ngay để nhận:</h3>
              <div className="space-y-4">
                {[
                  { icon: 'ri-file-text-line', text: 'Lịch trình chi tiết PDF' },
                  { icon: 'ri-price-tag-3-line', text: 'Báo giá tour chính xác' },
                  { icon: 'ri-gift-line', text: 'Ưu đãi đặc biệt tháng này' },
                  { icon: 'ri-customer-service-2-line', text: 'Tư vấn miễn phí 1-1' },
                  { icon: 'ri-passport-line', text: 'Hỗ trợ làm visa Mỹ' },
                  { icon: 'ri-calendar-check-line', text: 'Giữ chỗ ưu tiên' }
                ].map((item, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-10 h-10 bg-[#dbeafe] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <i className={`${item.icon} text-[#2563eb] text-xl`}></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gradient-to-r from-[#2563eb] to-[#3b82f6] rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6">Liên hệ trực tiếp</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-phone-line text-2xl mr-4 flex-shrink-0 mt-1"></i>
                  <div>
                    <div className="font-semibold">Hotline 24/7</div>
                    <div className="text-white/90">VN: 0889992466</div>
                    <div className="text-white/90">USA: +1 714 552 1068</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-mail-line text-2xl mr-4 flex-shrink-0 mt-1"></i>
                  <div>
                    <div className="font-semibold">Email</div>
                    <div className="text-white/90">info@phuotmy.com</div>
                    <div className="text-white/90">info@caravanusa.com</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-chat-3-line text-2xl mr-4 flex-shrink-0 mt-1"></i>
                  <div>
                    <div className="font-semibold">Zalo / WhatsApp</div>
                    <div className="text-white/90">0889992466</div>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-2xl mr-4 flex-shrink-0 mt-1"></i>
                  <div>
                    <div className="font-semibold">Văn phòng</div>
                    <div className="text-white/90">Hà Nội - Việt Nam</div>
                    <div className="text-white/90">California - Hoa Kỳ</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Registration Form */}
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Mẫu đăng ký - Nhận lịch & báo giá ngay</h3>
            
            <form id="hawaii-registration-form" data-readdy-form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Họ và tên <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all"
                  placeholder="Nguyễn Văn A"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all"
                  placeholder="email@example.com"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Số điện thoại / Zalo / WhatsApp <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  name="phoneZaloWhatsapp"
                  value={formData.phoneZaloWhatsapp}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all"
                  placeholder="0889992466"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Số khách <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    name="numberOfGuests"
                    value={formData.numberOfGuests}
                    onChange={handleChange}
                    min="1"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-semibold mb-2">
                    Chọn tour <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="tourType"
                    value={formData.tourType}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 pr-8 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all cursor-pointer"
                  >
                    <option value="2-island">Tour 2 Đảo (6 ngày)</option>
                    <option value="3-island">Tour 3 Đảo (9-10 ngày)</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Ngày dự kiến
                </label>
                <input
                  type="text"
                  name="expectedDate"
                  value={formData.expectedDate}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all"
                  placeholder="Tháng 6/2026, Tháng 7/2026..."
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Ghi chú / Yêu cầu riêng
                </label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2563eb] focus:border-transparent outline-none transition-all resize-none"
                  placeholder="Câu hỏi hoặc yêu cầu đặc biệt..."
                ></textarea>
                <div className="text-sm text-gray-500 mt-1 text-right">
                  {formData.notes.length}/500 ký tự
                </div>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-lg font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Đang gửi...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill mr-2"></i>
                    Nhận lịch & báo giá ngay
                  </>
                )}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 flex items-start">
                  <i className="ri-checkbox-circle-fill text-green-500 text-2xl mr-3 flex-shrink-0"></i>
                  <div>
                    <div className="font-semibold text-green-800">Đăng ký thành công!</div>
                    <div className="text-green-700 text-sm">Chúng tôi sẽ gửi lịch trình & báo giá chi tiết qua email trong vòng 24h.</div>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start">
                  <i className="ri-error-warning-fill text-red-500 text-2xl mr-3 flex-shrink-0"></i>
                  <div>
                    <div className="font-semibold text-red-800">Có lỗi xảy ra!</div>
                    <div className="text-red-700 text-sm">Vui lòng thử lại hoặc liên hệ hotline: 0889992466</div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
